import { saveAs } from 'file-saver';

export const getBlobFromUrl = (url: string): Promise<Blob> =>
  fetch(url).then((response) => response.blob());

export const downloadFileFromUrl = (url: string, fileName?: string) =>
  getBlobFromUrl(url).then((blob) => saveAs(blob, fileName));
